module.exports = __webpack_public_path__ + "img/feature-2.24f93a10.webp";